import { SCACEnum, SnackBarVariants } from '@app/app.enum';
import { ICarrierSCAC, ISCACListProps } from '@app/models';
import Injector from '@app/services';
import { MetaDataService } from '@app/services/meta-data.service';
import { SharedService } from '@app/services/shared.service';
import { GridList, GridListTile, GridListTileBar, Hidden, Typography } from '@material-ui/core';
import Axios from 'axios';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { injectIntl } from 'react-intl';
import withSnackBar from '../core/message.component';

const metaDataService: MetaDataService = Injector.get(MetaDataService);
const sharedService: SharedService = Injector.get(SharedService);

const getClassNames = (selectedCarrier: number, currentCarrier: number): string => {
	return selectedCarrier === currentCarrier ? 'selected-carrier' : '';
};

const applyBackgroundColor = (scac: SCACEnum): string => {
	return `${scac}-background`;
};

const SCACListComponent: React.FunctionComponent<ISCACListProps> = (props) => {
	const [selectedSCAC, updateSelectedSCAC] = useState<number>(null);
	const [scacList, setSCACList] = useState<ICarrierSCAC[]>([]);

	useEffect(() => {
		let mounted = true;
		if (mounted) {
			fetchAllSCACs();
		}
		return () => { mounted = false };
	}, []);

	const fetchAllSCACs = useCallback(async () => {
		try {
			const result = await metaDataService.getAllSCACs();
			setSCACList(result);
		} catch (err) {
			if (!Axios.isCancel(err)) {
				props.openSnackBar(sharedService.parseError(err.data), SnackBarVariants.Error);
			}
		}
	}, []);

	const getSCACImageTile = useCallback(
		(carrier: ICarrierSCAC, index: number) => {
			return (
				<GridListTile
					classes={{
						root: 'carrier-image',
						tile: `carriers-tile ${getClassNames(selectedSCAC, index)}`,
					}}
					onClick={(e: React.MouseEvent) => {
						e.preventDefault();
						props.onClick(carrier.scac);
						updateSelectedSCAC(index);
					}}
					key={index}
				>
					<div className={`carrier-img ${applyBackgroundColor(carrier.scac)}`}>
						<img src={carrier.logo} className='image-dimensions' />
					</div>
					<GridListTileBar
						classes={{ root: 'carrier-image-caption' }}
						title={
							<Typography variant='caption' color='textSecondary' noWrap={true}>
								<strong>{carrier.name}</strong>
							</Typography>
						}
					/>
				</GridListTile>
			);
		},
		[selectedSCAC]
	);

	const SCACListing = useMemo<JSX.Element[]>(() => {
		return scacList.map((element: ICarrierSCAC, index: number) => getSCACImageTile(element, index));
	}, [scacList, getSCACImageTile]);

	return (
		<div>
			<Hidden only={['xs', 'sm']}>
				<GridList
					classes={{
						root: `carrier-list`,
					}}
					cols={5}
					spacing={16}
				>
					{SCACListing}
				</GridList>
			</Hidden>
			<Hidden only={['sm', 'md', 'lg', 'xl']}>
				<GridList
					classes={{
						root: `carrier-list`,
					}}
					cols={2}
					spacing={16}
				>
					{SCACListing}
				</GridList>
			</Hidden>
			<Hidden only={['xs', 'md', 'lg', 'xl']}>
				<GridList
					classes={{
						root: `carrier-list`,
					}}
					cols={3}
					spacing={16}
				>
					{SCACListing}
				</GridList>
			</Hidden>
		</div>
	);
};

export default withSnackBar(injectIntl(SCACListComponent));



// WEBPACK FOOTER //
// ./src/components/carriers/scac-list.component.tsx